export default {
  placeholder: 'Wybierz format danych',
};
